import React from "react";
import { useNavigate } from "react-router-dom";

function BoardCardKey({ project, boardName, boardKey, handleDetails }) {
  const navigate = useNavigate();

  const key = boardName?.key || boardKey || project?.key;
  const isBoardPage = window.location.pathname.includes('/board/');
  
  const handleBoardKey = (event) => {
    if(isBoardPage) return;
    
    event.stopPropagation();
    event.preventDefault();
    
    // Check if modifier keys are pressed (Cmd/Ctrl or Shift)
    const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
    
    if (project && !isBoardPage) {
      const url = `/board/${key}`;
      
      if (isModifierPressed) {
        // Open in new tab/window
        window.open(url, '_blank');
      } else {
        navigate(url);
      }
    }
  };
  
  const handleCardClick = (event) => {
    // We want to allow the parent's handleDetails to work with modifier keys
    // Just stop propagation and don't prevent default to allow handleDetails to handle it
    event.stopPropagation();
    
    handleDetails(event);
  };
  
  return (
    <p className="card-id-number">
      <span onClick={handleBoardKey} className={`${isBoardPage ? '' : 'cursor-pointer board-id-label'} `}>
        {key}
      </span>
      -<span onClick={handleCardClick} className="cursor-pointer card-id-label">
        {project?.card?.card_id || project?.card_id}
      </span>
    </p>
  );
}

export default BoardCardKey;
